import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { prefix } = useParams();

  if (authLoading) return <LoadingScreen />;
  
  if (!isAuthenticated) {
    return <Navigate to={prefix ? `/${prefix}` : '/'} replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
